// articles/index.js — every article, newest first. Adding one: write the body
// component, add an entry here, and add its URL to public/sitemap.xml.

import WhatIsScorigami from "./WhatIsScorigami";
import RarestScorelines from "./RarestScorelines";
import HomeAwayScorigami from "./HomeAwayScorigami";

export const ARTICLES = [
  {
    slug: "home-away-scorigami",
    title: "Home and away: where the next Premier League scorigami will come from",
    description:
      "The classic scorigami count hasn't moved since 2013. Split by venue, the Premier League keeps producing new results, and an away 7–2 looks next.",
    lede:
      "Ignore which side was at home and the Premier League has not produced a brand-new final score since May 2013. Split every result by venue, though, and the grid starts moving again.",
    date: "2026-09-23",
    minutes: 4,
    Body: HomeAwayScorigami,
  },
  {
    slug: "rarest-premier-league-scorelines",
    title: "The rarest scorelines in Premier League history",
    description:
      "Six final scores have happened exactly once in the Premier League. The matches behind them, from Portsmouth 7–4 Reading to West Brom 5–5 Manchester United.",
    lede:
      "Of the 36 final scores the Premier League has produced since 1992, six have happened exactly once. Together they account for six of 13,216 matches, and all six came within six years of each other.",
    date: "2026-09-23",
    minutes: 5,
    Body: RarestScorelines,
  },
  {
    slug: "what-is-scorigami",
    title: "What is a scorigami? The Premier League edition",
    description:
      "Where the word comes from, why football produces so few of them, and how to read the Premier League scorigami grid.",
    lede:
      "A scorigami is a final score that has never happened before. In the Premier League, where goals are scarce and the same results come round every weekend, one is rarer than you might think.",
    date: "2026-09-23",
    minutes: 4,
    Body: WhatIsScorigami,
  },
];

export const articleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);

export const formatArticleDate = (iso) =>
  new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
